import styled from 'styled-components';

export const CenterFlex = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CenterGrid = styled.div`
  display: grid;
  place-items: center;
`;

export const WrapperInfo = styled.div`
  display: grid;
  gap: 10px;
  margin: 32px 0;
`;

export const ContentTitre = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
`;
export const CenterComponent = styled(CenterFlex)`
  height: 80vh;
`;

export const WarapperTextContent = styled(CenterGrid)`
  gap: 16px;
`;
